import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip'
import './CalendarMonthCell.css';

class CalendarMonthCell extends Component {


	render() {

		let holidayNames = {
			'5' : 'Weihnachtsferien',
			'semesterferien' : 'Semesterferien',
			'osterferien' : 'Osterferien',
			'pfingstferien' : 'Pfingstferien',
			'sommerferien' : 'Sommerferien',
			'weihnachtsferien' : 'Weihnachtsferien',
			'Schulautonomer Tag' : 'Schulautonomer Tag'
		}

		let holidayInfo = this.props.isSchoolHoliday ? ' schoolHoliday' : '';
		holidayInfo += this.props.isPublicHoliday ? ' publicHoliday' : '';
		holidayInfo += this.props.isToday ? ' currentDay' : '';
		holidayInfo += (!this.props.isLegal && this.props.isPublicHoliday) ? ' notLegal' : '';
		let weekDay = this.props.weekDay ? ' day-' + this.props.weekDay % 7 : ' kw';
		let backgroundColor = (this.props.isPublicHoliday && this.props.colors) ? this.props.colors[0] : (this.props.isSchoolHoliday && this.props.colors) ? this.props.colors[1] : '';
		let holidayName = (this.props.isSchoolHoliday) ? holidayNames[this.props.holidayName] : this.props.holidayName;
		let tooltip = (holidayName) ? <ReactTooltip /> : '';


		return (
			<div className={'CalendarMonthCell' + holidayInfo + weekDay}>
				<div className="CalendarMonthCell-content" style={{backgroundColor: backgroundColor}} data-tip={holidayName} data-event="click"><span>{this.props.content}</span></div>
				{tooltip}
			</div>
		);
	}
}

export default CalendarMonthCell;



// WEBPACK FOOTER //
// ./src/components/CalendarMonthCell.js